import { useDispatch, useSelector } from "react-redux";
import { genesysRefresh } from "../services/liveAgentService.js";
import { END_MSG, IDLE_MSG } from "../../constants.js";
import { formatMessageData } from "../utils/formatData.js";
import {
    incrementPosition,
    concatMessage,
    setMessages,
    setIsEnd,
    clearRefresher,
    setRefresher
} from "../features/messagesSlice.js";
import { clearQueueScheduler, setConnectedLiveAgent, setConnectingLiveAgent } from "../features/liveAgentSlice.js";

export default function useRefreshData() {
    const dispatch = useDispatch();
    const refresher = useSelector(state => state.messages.refresher);
    const expiredScheduler = useSelector(state => state.messages.expiredScheduler);
    const queueScheduler = useSelector(state => state.liveAgent.queueScheduler);
    const messages = useSelector(state => state.messages.messages);
    const deviceId = useSelector(state => state.session.deviceId);
    const position = useSelector(state => state.messages.position);
    const genesysDetails = useSelector(state => state.liveAgent.genesysDetails);
    const lastMessagePosition = useSelector(state => state.messages.lastMessagePosition);
    const expiredAt = useSelector(state => state.messages.expiredAt);
    const connectingLiveAgent = useSelector(state => state.liveAgent.connectingLiveAgent);
    const connectedLiveAgent = useSelector(state => state.liveAgent.connectedLiveAgent);
    const isEnd = useSelector(state => state.messages.isEnd);

    const refreshChat = async () => {
        if (refresher) return;
        if (!messages) {
            console.error("No messages provided to refreshChat");
            return;
        }

        if (connectedLiveAgent && !refresher && !isEnd) {
            const new_refresher = setInterval(async () => {
                try {
                    const genesysRefreshData = await genesysRefresh(
                        genesysDetails.chatId,
                        genesysDetails.userId,
                        genesysDetails.secureKey,
                        genesysDetails.alias,
                    );
                    const {
                        messages: liveAgentMessages,
                        chatEnded,
                    } = genesysRefreshData;

                    const allGenesysMessages = liveAgentMessages.filter((message) => ((message.type === "Message") && (message.from.type !== "External")));
                    let lst = [];
                    allGenesysMessages.forEach(message => {
                        // let liveAgentPosition = messages[messages.length - 1].position;
                        const messageData = formatMessageData(deviceId, message.from.type === "Client" ? "user" : "agent", message.text, position, "normal", message.utcTime);
                        dispatch(incrementPosition());
                        lst.push(messageData);
                    });

                    // If chatEnded
                    if (chatEnded || liveAgentMessages.filter((message) => message.type === "ParticipantLeft" && message.from.type === "Agent").length > 0) {
                        dispatch(setIsEnd(true));
                        clearInterval(new_refresher);
                        dispatch(clearRefresher());
                        clearInterval(queueScheduler);
                        dispatch(clearQueueScheduler());
                        const message = formatMessageData(deviceId, "bot", END_MSG, position);
                        dispatch(incrementPosition());
                        dispatch(setMessages([
                            ...messages.slice(0, lastMessagePosition + 1),
                            ...lst,
                            message
                        ]));
                        clearInterval(expiredScheduler);
                        dispatch(setConnectedLiveAgent(false));
                        dispatch(setConnectingLiveAgent(false));
                    } else {
                        dispatch(setMessages([
                            ...messages,
                            ...lst
                        ]));
                    }
                } catch (error) {
                    clearInterval(new_refresher);
                    console.error("Error refreshing chat:", error);
                }
            }, 3000);
            dispatch(setRefresher(new_refresher));
        }
    };

    const handleExpirySchedule = () => {
        const timeNow = new Date();
        const isExpired = expiredAt < timeNow;

        // End chat after 6 minutes
        if (isExpired) {
            dispatch(setIsEnd(true));
            clearInterval(expiredScheduler);
        } else {
            if (!connectingLiveAgent && !connectedLiveAgent) {
                const isHalf = timeNow >= new Date(expiredAt).getTime() - 3 * 60000;
                if (isHalf) {
                    const lastIdleMessage = messages.slice().reverse().find(msg => msg.content === IDLE_MSG);
                    if (!lastIdleMessage || new Date(lastIdleMessage?.created_at) <= new Date(timeNow - (3 * 60000))) {
                        const message = formatMessageData(deviceId, "bot", IDLE_MSG, position);
                        dispatch(concatMessage(message));
                        dispatch(incrementPosition());
                    }
                }
            } else {
                clearInterval(expiredScheduler);
            }
        }
    };

    return { refreshChat, handleExpirySchedule };
};
